import CollectionIcon from "../assets/icons/active-collection.svg";
import CreatorFooterProfileActiveIcon from "../assets/icons/creator/footer/profile-active2.svg";
import CreatorFooterProfileIcon from "../assets/icons/creator/footer/profile.svg";
import CreatorFooterRevenueActiveIcon from "../assets/icons/creator/footer/revenue-active.svg";
import CreatorFooterRevenueIcon from "../assets/icons/creator/footer/revenue.svg";
import FanFooterHomeActiveIcon from "../assets/icons/fan/footer/footer-home-active.svg";
import FanFooterHomeIcon from "../assets/icons/fan/footer/footer-home.svg";
import FanFooterLiveActiveIcon from "../assets/icons/fan/footer/footer-live-active.svg";
import FanFooterLiveIcon from "../assets/icons/fan/footer/footer-live.svg";
import FanFooterMessageIcon from "../assets/icons/fan/footer/footer-messaage.svg";
import FanFooterMessageActiveIcon from "../assets/icons/fan/footer/footer-message-active.svg";
import FanFooterParametersActiveIcon from "../assets/icons/fan/footer/footer-parameters-active.svg";
import FanFooterParametersIcon from "../assets/icons/fan/footer/footer-parameters.svg";
import FanFooterSearchActiveIcon from "../assets/icons/fan/footer/footer-search-active.svg";
import FanFooterSearchIcon from "../assets/icons/fan/footer/footer-search.svg";
import LightningIcon from "../assets/icons/lightning.svg";
import UnlockIcon from "../assets/icons/lock-unlock.svg";
import CreatorFooterCollectionIcon from "../assets/icons/menu-collection.svg";
import CreatorFooterDecryptIcon from "../assets/icons/menu-decrypt.svg";
import CreatorFooterLiveIcon from "../assets/icons/menu-live.svg";
import CreatorFooterPostIcon from "../assets/icons/menu-post.svg";
import CreatorFooterPushIcon from "../assets/icons/menu-push.svg";
import BaliseIcon from "../assets/icons/settings/balise.svg";
import BankIcon from "../assets/icons/settings/banque.svg";
import BilletAlternatifIcon from "../assets/icons/settings/billet-alternatif.svg";
import BloquerIcon from "../assets/icons/settings/bloquer.svg";
import BookIcon from "../assets/icons/settings/book.svg";
import BoueeIcon from "../assets/icons/settings/bouee-de-sauvetage.svg";
import CarteCreditIcon from "../assets/icons/settings/carte-de-credit.svg";
import DeconnexionIcon from "../assets/icons/settings/deconnexion1.svg";
import DocumentIcon from "../assets/icons/settings/document.svg";
import DossierIcon from "../assets/icons/settings/dossier.svg";
import MailIcon from "../assets/icons/settings/mail.svg";
import PorteDocumentIcon from "../assets/icons/settings/porte-documents-vierge.svg";
import PresentationVideoIcon from "../assets/icons/settings/presentation-video.svg";
import QuestionIcon from "../assets/icons/settings/question.svg";
import SacIcon from "../assets/icons/settings/sac.svg";
import UserIcon from "../assets/icons/settings/user.svg";
import ArtisteImg from "../assets/images/category/artiste-2.webp";
import BackstageImg from "../assets/images/category/celebrities-2.webp";
import CoupleGoalImg from "../assets/images/category/couple-goal-2.webp";
import CuisineImg from "../assets/images/category/cuisine-2.webp";
import MoinsImg from "../assets/images/category/de-25-ans-2.webp";
import FemmeRondeImg from "../assets/images/category/femmes-rondes-2.webp";
import GamblerImg from "../assets/images/category/gambler-2.webp";
import InfluenceeursImg from "../assets/images/category/influenceurs-2.webp";
import LgbtqImg from "../assets/images/category/lgbtq-2.webp";
import LingerieImg from "../assets/images/category/lingerie-2.webp";
import NoLimitImg from "../assets/images/category/no-limit-2.webp";
import PiedsImg from "../assets/images/category/pieds-2.webp";
import SportifImg from "../assets/images/category/sportif-2.webp";
import { signOutClicked } from "../utls/FunctionsUtil";
import { ISelectType } from "./types";

const LIVE_TYPES = {
  NOW: "now",
  SCHEDULE: "schedule",
};

const PAYMENT_TYPES = {
  LIVE: "live",
  LIVE_TIP: "live_tip",
  COLLECTION: "collection",
  MEDIA_PUSH: "mediaPush",
  SUBSCRIPTION: "subscription",
};

const profiles = [
  {
    image: "https://newprofilepic2.photo-cdn.net//assets/images/article/profile.jpg",
    name: "Jeff_Seid",
  },
  {
    image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQnPsHyxR_Y76c6PdW01ru33Nu4uvoHKrGeGW-lab4SxBRIqaka6qyvrojRZxv85WJmgjY&usqp=CAU",
    name: "Leamary12",
  },
  {
    image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRZGrcVsaDt1KYSqHh6AcIS1cNreZvf6TCGWgzVdfGvRTu9AXBRcy0-oRoVJgXBKAdL8qM&usqp=CAU",
    name: "Julie1994",
  },
  {
    image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSAu3aUAvI-23fO7gkQjjuHtGVpkrsiEoARlaIIZlSG4k5ief-8uKUaT1DkkS72mfDHFtg&usqp=CAU",
    name: "Jeff_Seid",
  },
  {
    image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQZnEK0TWYYy4Htx4TBq6Tg5edf4lElbV3vfnekOa1sqTffOJgFBqlpfcY7LpNehn70pvo&usqp=CAU",
    name: "Leamary12",
  },
];

const posts = [
  {
    name: "Jess_Seid",
    favoriteAmount: 100,
    avatar: "https://newprofilepic2.photo-cdn.net//assets/images/article/profile.jpg",
    postImage: "https://townsquare.media/site/1096/files/2020/08/OnlyFans-Bella-Thorne-min.jpg",
  },
  {
    name: "Leamary12",
    favoriteAmount: 110,
    avatar: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQnPsHyxR_Y76c6PdW01ru33Nu4uvoHKrGeGW-lab4SxBRIqaka6qyvrojRZxv85WJmgjY&usqp=CAU",
    postImage: "https://i2-prod.dublinlive.ie/incoming/article25415219.ece/ALTERNATES/s810/0_Hannah-and-James-OnlyFans-couple.jpg",
  },
  {
    name: "Julie1994",
    favoriteAmount: 120,
    avatar: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRZGrcVsaDt1KYSqHh6AcIS1cNreZvf6TCGWgzVdfGvRTu9AXBRcy0-oRoVJgXBKAdL8qM&usqp=CAU",
    postImage: "https://pbs.twimg.com/media/EgSzcBaXsAISbrj?format=jpg",
  },
  {
    name: "Jeff_Seid",
    favoriteAmount: 120,
    avatar: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSAu3aUAvI-23fO7gkQjjuHtGVpkrsiEoARlaIIZlSG4k5ief-8uKUaT1DkkS72mfDHFtg&usqp=CAU",
    postImage: "https://revolutionaryprogramdesign.com/wp-content/uploads/2023/01/How-To-Make-Money-On-Onlyfans-768x427.jpg",
  },
];

const profile = {
  name: "Dorian Wéry ",
  avatar: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQnPsHyxR_Y76c6PdW01ru33Nu4uvoHKrGeGW-lab4SxBRIqaka6qyvrojRZxv85WJmgjY&usqp=CAU",
  background: "https://revolutionaryprogramdesign.com/wp-content/uploads/2023/01/How-To-Make-Money-On-Onlyfans-768x427.jpg",
  city: "Paris",
  publications: 456,
  subscribers: 2034,
  title: "Body Addict 🏋️‍♀ Suis moi si tu veux en voir + 👀",
  posts: [
    {
      image: "https://revolutionaryprogramdesign.com/wp-content/uploads/2023/01/How-To-Make-Money-On-Onlyfans-768x427.jpg",
      isPrivate: false,
    },
    {
      image: "https://pbs.twimg.com/media/EgSzcBaXsAISbrj?format=jpg",
      isPrivate: false,
    },
    {
      image: "https://i2-prod.dublinlive.ie/incoming/article25415219.ece/ALTERNATES/s810/0_Hannah-and-James-OnlyFans-couple.jpg",
      isPrivate: true,
    },
    {
      image: "https://townsquare.media/site/1096/files/2020/08/OnlyFans-Bella-Thorne-min.jpg",
      isPrivate: true,
    },
    {
      image: "https://townsquare.media/site/1096/files/2020/08/OnlyFans-Bella-Thorne-min.jpg",
      isPrivate: true,
    },
    {
      image: "https://revolutionaryprogramdesign.com/wp-content/uploads/2023/01/How-To-Make-Money-On-Onlyfans-768x427.jpg",
      isPrivate: false,
    },
    {
      image: "https://pbs.twimg.com/media/EgSzcBaXsAISbrj?format=jpg",
      isPrivate: false,
    },
    {
      image: "https://i2-prod.dublinlive.ie/incoming/article25415219.ece/ALTERNATES/s810/0_Hannah-and-James-OnlyFans-couple.jpg",
      isPrivate: true,
    },
    {
      image: "https://townsquare.media/site/1096/files/2020/08/OnlyFans-Bella-Thorne-min.jpg",
      isPrivate: true,
    },
  ],
};

const messages = [
  {
    name: "Lea Mary",
    userName: "lea",
    avatar: "https://revolutionaryprogramdesign.com/wp-content/uploads/2023/01/How-To-Make-Money-On-Onlyfans-768x427.jpg",
    onlineStatus: "En ligne il y a 1h",
    isOnline: false,
  },
  {
    name: "Jeff Seid",
    userName: "jeff",
    avatar: "https://pbs.twimg.com/media/EgSzcBaXsAISbrj?format=jpg",
    onlineStatus: "En ligne ",
    isOnline: true,
    isVerified: true,
  },
  {
    name: "Lea Mary",
    userName: "lea",
    avatar: "https://i2-prod.dublinlive.ie/incoming/article25415219.ece/ALTERNATES/s810/0_Hannah-and-James-OnlyFans-couple.jpg",
    onlineStatus: "En ligne ",
    isOnline: true,
    isNewMessage: true,
  },
  {
    name: "Jeff Seid",
    userName: "jeff",
    avatar: "https://pbs.twimg.com/media/EgSzcBaXsAISbrj?format=jpg",
    onlineStatus: "En ligne ",
    isOnline: true,
    isVerified: true,
  },
  {
    name: "Lea Mary",
    userName: "lea",
    avatar: "https://i2-prod.dublinlive.ie/incoming/article25415219.ece/ALTERNATES/s810/0_Hannah-and-James-OnlyFans-couple.jpg",
    onlineStatus: "En ligne ",
    isOnline: true,
    isNewMessage: true,
  },
  {
    name: "Lea Mary",
    userName: "lea",
    avatar: "https://revolutionaryprogramdesign.com/wp-content/uploads/2023/01/How-To-Make-Money-On-Onlyfans-768x427.jpg",
    onlineStatus: "En ligne il y a 1h",
    isOnline: false,
  },
];

const categories = [
  {
    id: "curvy-woman",
    name: "Femme ronde",
    img: FemmeRondeImg,
    title: "round-woman-title-category",
    description: "round-woman-description-category",
  },
  {
    id: "no-limit",
    name: "No limit",
    img: NoLimitImg,
    title: "nolimit-title-category",
    description: "nolimit-description-category",
  },
  {
    id: "celebrity-backstage",
    name: "Backstage de célébrités",
    img: BackstageImg,
    title: "celebrities-title-category",
    description: "celebrities-description-category",
  },
  {
    id: "foot-lover",
    name: "Qui aime les pieds",
    img: PiedsImg,
    title: "foot-title-category",
    description: "foot-description-category",
  },
  {
    id: "lingerie",
    name: "Lingerie",
    img: LingerieImg,
    title: "underwear-title-category",
    description: "underwear-description-category",
  },
  {
    id: "lgbtq",
    name: "LGBTQ+",
    img: LgbtqImg,
    title: "lgbtq-title-category",
    description: "lgbtq-description-category",
  },
  {
    id: "in-relationship",
    name: "En couple",
    img: CoupleGoalImg,
    title: "couple-title-category",
    description: "couple-description-category",
  },
  {
    id: "model",
    name: "Moins de 25 ans",
    img: MoinsImg,
    title: "under-25-title-category",
    description: "under-25-description-category",
  },
  {
    id: "influencer",
    name: "Influenceur/seuse",
    img: InfluenceeursImg,
    title: "influencer-title-category",
    description: "influencer-description-category",
  },
  {
    id: "fitness-coaching",
    name: "Coaching Sportif",
    img: SportifImg,
    title: "sport-title-category",
    description: "sport-description-category",
  },
  {
    id: "cooking",
    name: "Cuisine",
    img: CuisineImg,
    title: "food-title-category",
    description: "food-description-category",
  },
  {
    id: "gambler",
    name: "Gambler (trading, jeu,...)",
    img: GamblerImg,
    title: "gambler-title-category",
    description: "gambler-description-category",
  },
  {
    id: "artist",
    name: "Artiste",
    img: ArtisteImg,
    title: "artist-title-category",
    description: "artist-description-category",
  },
];

const privateGalleries = [
  "https://revolutionaryprogramdesign.com/wp-content/uploads/2023/01/How-To-Make-Money-On-Onlyfans-768x427.jpg",
  "https://pbs.twimg.com/media/EgSzcBaXsAISbrj?format=jpg",
  "https://i2-prod.dublinlive.ie/incoming/article25415219.ece/ALTERNATES/s810/0_Hannah-and-James-OnlyFans-couple.jpg",
  "https://townsquare.media/site/1096/files/2020/08/OnlyFans-Bella-Thorne-min.jpg",
  "https://townsquare.media/site/1096/files/2020/08/OnlyFans-Bella-Thorne-min.jpg",
  "https://revolutionaryprogramdesign.com/wp-content/uploads/2023/01/How-To-Make-Money-On-Onlyfans-768x427.jpg",
  "https://pbs.twimg.com/media/EgSzcBaXsAISbrj?format=jpg",
  "https://i2-prod.dublinlive.ie/incoming/article25415219.ece/ALTERNATES/s810/0_Hannah-and-James-OnlyFans-couple.jpg",
  "https://townsquare.media/site/1096/files/2020/08/OnlyFans-Bella-Thorne-min.jpg",
];

const lives = [
  {
    user: {
      name: "Jeff_Seid",
      avatar: "https://pbs.twimg.com/media/EgSzcBaXsAISbrj?format=jpg",
      isVerified: true,
    },
    image: "https://revolutionaryprogramdesign.com/wp-content/uploads/2023/01/How-To-Make-Money-On-Onlyfans-768x427.jpg",
    spectateurs: "1.9K",
  },
  {
    user: {
      name: "Lea Mary",
      avatar: "https://i2-prod.dublinlive.ie/incoming/article25415219.ece/ALTERNATES/s810/0_Hannah-and-James-OnlyFans-couple.jpg",
      isVerified: true,
    },
    image: "https://pbs.twimg.com/media/EgSzcBaXsAISbrj?format=jpg",
    spectateurs: "376",
  },
  {
    user: {
      name: "Jeff Seid",
      avatar: "https://pbs.twimg.com/media/EgSzcBaXsAISbrj?format=jpg",
      isVerified: true,
    },
    image: "https://i2-prod.dublinlive.ie/incoming/article25415219.ece/ALTERNATES/s810/0_Hannah-and-James-OnlyFans-couple.jpg",
    spectateurs: "1.9K",
  },
  {
    user: {
      name: "Lea Mary",
      avatar: "https://i2-prod.dublinlive.ie/incoming/article25415219.ece/ALTERNATES/s810/0_Hannah-and-James-OnlyFans-couple.jpg",
      isVerified: true,
    },
    image: "https://townsquare.media/site/1096/files/2020/08/OnlyFans-Bella-Thorne-min.jpg",
    spectateurs: "376",
  },
  {
    user: {
      name: "Lea Mary",
      avatar: "https://revolutionaryprogramdesign.com/wp-content/uploads/2023/01/How-To-Make-Money-On-Onlyfans-768x427.jpg",
      isVerified: true,
    },
    image: "https://revolutionaryprogramdesign.com/wp-content/uploads/2023/01/How-To-Make-Money-On-Onlyfans-768x427.jpg",
    spectateurs: "1.9K",
  },
];

const comments = [
  {
    user: {
      name: "Jeff Seid",
      avatar: "https://pbs.twimg.com/media/EgSzcBaXsAISbrj?format=jpg",
      isVerified: true,
    },
    comment: "Hello je suis trop fan de toi, possible que tu dise mon prenom ? ",
  },
  {
    user: {
      name: "Lea Mary",
      avatar: "https://revolutionaryprogramdesign.com/wp-content/uploads/2023/01/How-To-Make-Money-On-Onlyfans-768x427.jpg",
      isVerified: true,
    },
    comment: "Tu vas bien ? ",
  },
  {
    user: {
      name: "Jeff_Seid",
      avatar: "https://pbs.twimg.com/media/EgSzcBaXsAISbrj?format=jpg",
      isVerified: true,
    },
    comment: "Hello je suis trop fan de toi, possible que tu dise mon prenom ? ",
  },
  {
    user: {
      name: "Jeff Seid",
      avatar: "https://pbs.twimg.com/media/EgSzcBaXsAISbrj?format=jpg",
      isVerified: true,
    },
    comment: "hello tu vas toujours au basic fit de porte de la chappelle ? ",
  },
];

const revenues = [
  {
    date: "Avril 2023",
    percent: "+22,77",
    price: "21 890,55",
    increased: true,
  },
  {
    date: "Mars 2023",
    percent: "-2,77",
    price: "19 555,55",
    increased: false,
  },
  {
    date: "Avril 2023",
    percent: "+22,77",
    price: "21 890,55",
    increased: true,
  },
  {
    date: "Mars 2023",
    percent: "-2,77",
    price: "19 555,55",
    increased: false,
  },
];

const privateMedias = [
  "https://revolutionaryprogramdesign.com/wp-content/uploads/2023/01/How-To-Make-Money-On-Onlyfans-768x427.jpg",
  "https://townsquare.media/site/1096/files/2020/08/OnlyFans-Bella-Thorne-min.jpg",
  "https://i2-prod.dublinlive.ie/incoming/article25415219.ece/ALTERNATES/s810/0_Hannah-and-James-OnlyFans-couple.jpg",
  "https://pbs.twimg.com/media/EgSzcBaXsAISbrj?format=jpg",
  "https://revolutionaryprogramdesign.com/wp-content/uploads/2023/01/How-To-Make-Money-On-Onlyfans-768x427.jpg",
];

const PROMOTION_DISCOUNT_TYPE = {
  currency: "CURRENCY",
  percentage: "PERCENTAGE",
};

const PROMOTION_PROMO_ON = {
  subscribers: "SUBSCRIBERS",
  mediaPush: "MEDIA_PUSH",
};

const PRMOTION_EXPIRATION_TIME_TYPE = {
  hours: "HOURS",
  days: "DAYS",
  months: "MONTHS",
  years: "YEARS",
  unlimited: "UNLIMITED",
};

const getGenders = (t: any) => {
  return [
    {
      label: t("gender-male"),
      value: "male",
    },
    {
      label: t("gender-female"),
      value: "female",
    },
    {
      label: t("gender-other"),
      value: "other",
    },
  ];
};

const getMonetizationsInformations = (t: any) => {
  return [
    {
      title: t("monetization-monthly-offer"),
      subTitle: t("monetization-euro-month"),
      important: true,
      frequency: "monthly",
    },
    {
      title: t("monetization-quarterly-offer"),
      subTitle: t("monetization-euro-quarter"),
      frequency: "trimestrial",
    },
    // {
    //   title: t("monetization-half-annual-offer"),
    //   subTitle: t("monetization-euro-half-year"),
    //   frequency: "half_yearly",
    // },
    // {
    //   title: t("monetization-annual-offer"),
    //   subTitle: t("monetization-euro-year"),
    //   frequency: "yearly",
    // },
  ];
};

const getEmailNotifications = (t: any) => {
  return [
    {
      title: t("media-push-from-creator"),
      subTitle: t("media-push-from-creator-message"),
      important: true,
      frequency: "mediaPush",
    },
    {
      title: t("live-reminder"),
      subTitle: t("live-reminder-message"),
      frequency: "reminderStream",
    },
    {
      title: t("schedule-live"),
      subTitle: t("schedule-live-message"),
      frequency: "scheduleStream",
    },
    {
      title: t("direct-live"),
      subTitle: t("direct-live-message"),
      frequency: "stream",
    },
    {
      title: t("marketing"),
      subTitle: t("promotional-emails-from-platform"),
      frequency: "marketing",
    },
  ];
};

const getFanSettings = (t: any) => {
  return [
    {
      header: t("tools"),
      list: [
        {
          title: t("personal-information"),
          link: "/common/personalInformations",
          legal: false,
          logo: DocumentIcon,
        },
        {
          title: t("my-creators"),
          link: "/fan/subscription",
          legal: false,
          logo: CarteCreditIcon,
        },
        {
          title: t("change-password"),
          link: "/common/changePassword",
          legal: false,
          logo: PorteDocumentIcon,
        },
        {
          title: t("language"),
          link: "/common/language",
          legal: false,
          logo: BaliseIcon,
        },
      ],
    },
    {
      header: t("account"),
      list: [
        {
          title: t("help-and-contact"),
          link: "/common/helpContact",
          legal: false,
          logo: BoueeIcon,
        },
        {
          title: t("spotted-a-bug"),
          link: "/fan/spottedbug",
          legal: false,
          logo: QuestionIcon,
        },
      ],
    },
    {
      header: t("legal"),
      list: [
        {
          title: t("email-Notification-title"),
          link: "/fan/emailNotification",
          legal: false,
          logo: MailIcon,
        },
        {
          title: t("terms-and-conditions-of-sale"),
          link: "/common/general-conditions-of-sale",
          legal: false,
          logo: DossierIcon,
        },
        {
          title: t("community-regulations"),
          link: "/common/general-conditions-of-use",
          legal: false,
          logo: DossierIcon,
        },
        {
          title: t("content-policy"),
          link: "/common/content-policy-and-child-protection",
          legal: false,
          logo: DossierIcon,
        },
        {
          title: t("disconnect"),
          link: signOutClicked,
          legal: false,
          logo: DeconnexionIcon,
          isFunction: true,
        },
      ],
    },
  ];
};

const getCreatorSettings = (t: any) => {
  return [
    {
      header: t("tools"),
      list: [
        {
          title: t("profile-settings"),
          link: "/creator/editProfile",
          legal: false,
          logo: UserIcon,
        },
        {
          title: t("scripts"),
          link: "/creator/chat-scripts",
          legal: false,
          logo: BookIcon,
        },
        {
          title: t("subscription-price"),
          link: "/creator/monetization",
          legal: false,
          logo: SacIcon,
        },
        {
          title: t("automatic-message"),
          link: "/creator/message-automatic",
          legal: false,
          logo: LightningIcon,
        },
        // {
        //   title: t("quick-message"),
        //   link: "/creator/quick/message",
        //   legal: false,
        //   logo: FilesIcon,
        // },
        // hidden for the moment, we will enable it later
        /* {
          title: t("sponsorship"),
          link: "/creator/sponsorship",
          legal: false,
          logo: ClonerIcon,
        }, */
        {
          title: t("promo-code"),
          link: "/creator/codePromotions",
          legal: false,
          logo: BilletAlternatifIcon,
        },
      ],
    },
    {
      header: t("bank"),
      list: [
        {
          title: t("tutorial-presentation-videos"),
          link: "/creator/create/presentation/videos",
          legal: false,
          logo: PresentationVideoIcon,
        },
        {
          title: t("payments-history"),
          link: "/creator/paymentHistory",
          legal: false,
          logo: BankIcon,
        },
        {
          title: t("payment-method"),
          link: "/creator/paymentMethod",
          legal: false,
          logo: PorteDocumentIcon,
        },
        {
          title: t("pushes-history"),
          link: "/creator/historyMediaPush",
          legal: false,
          logo: BaliseIcon,
        },
        {
          title: t("unlock-history"),
          link: "/creator/decrypt",
          legal: false,
          logo: UnlockIcon,
        },
        {
          title: t("history-collections"),
          link: "/creator/collection",
          legal: false,
          logo: CollectionIcon,
        },
      ],
    },
    {
      header: t("account"),
      list: [
        {
          title: t("manager"),
          link: "/creator/invitation-manager",
          legal: false,
          logo: BilletAlternatifIcon,
        },
        {
          title: t("personal-information"),
          link: "/common/personalInformations",
          legal: false,
          logo: CarteCreditIcon,
        },
        {
          title: t("change-password"),
          link: "/common/changePassword",
          legal: false,
          logo: BloquerIcon,
        },
        {
          title: t("language"),
          link: "/common/language",
          legal: false,
          logo: BaliseIcon,
        },
        {
          title: t("help-and-contact"),
          link: "/common/helpContact",
          legal: false,
          logo: BoueeIcon,
        },
      ],
    },
    {
      header: t("legal"),
      list: [
        {
          title: t("terms-and-conditions-of-sale"),
          link: "/common/general-conditions-of-sale",
          legal: false,
          logo: DossierIcon,
        },
        {
          title: t("community-regulations"),
          link: "/common/general-conditions-of-use",
          legal: false,
          logo: DossierIcon,
        },
        {
          title: t("content-policy"),
          link: "/common/content-policy-and-child-protection",
          legal: false,
          logo: DossierIcon,
        },
        {
          title: t("disconnect"),
          link: signOutClicked,
          legal: false,
          logo: DeconnexionIcon,
          isFunction: true,
        },
      ],
    },
  ];
};

const getDiscountExpirePeriods = (t: any) => {
  return [
    {
      label: t("unlimited"),
      value: {
        timeType: "UNLIMITED",
        value: "0",
      },
    },
    {
      label: `6 ${t("hours")}`,
      value: {
        timeType: "HOURS",
        value: "6",
      },
    },
    {
      label: `12 ${t("hours")}`,
      value: {
        timeType: "HOURS",
        value: "12",
      },
    },
    {
      label: `24 ${t("hours")}`,
      value: {
        timeType: "HOURS",
        value: "24",
      },
    },
    {
      label: `2 ${t("days")}`,
      value: {
        timeType: "DAYS",
        value: "2",
      },
    },
    {
      label: `7 ${t("days")}`,
      value: {
        timeType: "DAYS",
        value: "7",
      },
    },
  ];
};

const getLiveAccesses = (t: any): ISelectType[] => {
  return [
    {
      label: t("everyone"),
      value: "all",
    },
    {
      label: t("subscribers"),
      value: "subscribers",
    },
  ];
};

const getDiscountTypes = (t: any) => {
  return {
    subscribers: t("subscription"),
    mediaPush: `${t("media-push")} / ${t("collection")}`,
  };
};

const getMediaAmounts = (t: any) => {
  return [
    {
      label: t("free"),
      value: "0",
    },
    {
      label: "15€",
      value: "15",
    },
    {
      label: "30€",
      value: "30",
    },
    {
      label: "50€",
      value: "50",
    },
    {
      label: "80€",
      value: "80",
    },
    {
      label: "100€",
      value: "100",
    },
    {
      label: "115€",
      value: "115",
    },
    {
      label: "150€",
      value: "150",
    },
  ];
};

const getLiveAmounts = () => {
  return [
    {
      label: "5€",
      value: "5",
    },
    {
      label: "15€",
      value: "15",
    },
    {
      label: "30€",
      value: "30",
    },
    {
      label: "50€",
      value: "50",
    },
    {
      label: "80€",
      value: "80",
    },
    {
      label: "100€",
      value: "100",
    },
    {
      label: "115€",
      value: "115",
    },
    {
      label: "150€",
      value: "150",
    },
  ];
};

const getCollectionAmounts = () => {
  return [
    {
      label: "15€",
      value: "15",
    },
    {
      label: "30€",
      value: "30",
    },
    {
      label: "50€",
      value: "50",
    },
    {
      label: "80€",
      value: "80",
    },
    {
      label: "100€",
      value: "100",
    },
    {
      label: "115€",
      value: "115",
    },
    {
      label: "150€",
      value: "150",
    },
    {
      label: "290€",
      value: "290",
    },
  ];
};

const getNotifications = (t: any) => {
  return [
    {
      header: `${t("last")} 24h`,
      list: [
        {
          name: "Julie Matt",
          verifiedUser: true,
          avatar: "https://newprofilepic2.photo-cdn.net//assets/images/article/profile.jpg",
          content: t("to-start-a-live"),
          time: "20 mins",
        },
        {
          name: "Jeff Seïd",
          avatar:
            "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQnPsHyxR_Y76c6PdW01ru33Nu4uvoHKrGeGW-lab4SxBRIqaka6qyvrojRZxv85WJmgjY&usqp=CAU",
          content: t("sent-you-a-private-proposal"),
          time: "1h",
        },
        {
          name: "Julie Matt",
          avatar:
            "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRZGrcVsaDt1KYSqHh6AcIS1cNreZvf6TCGWgzVdfGvRTu9AXBRcy0-oRoVJgXBKAdL8qM&usqp=CAU",
          content: t("to-schedule-a-live"),
          time: "1h",
        },
        {
          name: "Julie Matt",
          avatar: "https://newprofilepic2.photo-cdn.net//assets/images/article/profile.jpg",
          content: t("to-schedule-a-live"),
          time: "1h",
        },
      ],
    },
    {
      header: t("this-month"),
      list: [
        {
          name: "Jeff Seïd",
          verifiedUser: true,
          content: `${t("will-be-live-in")} 30 minutes`,
          avatar: "https://newprofilepic2.photo-cdn.net//assets/images/article/profile.jpg",
          time: `1${t("d")}`,
        },
        {
          name: "Julie Matt",
          content: t("to-start-a-live"),
          avatar:
            "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQnPsHyxR_Y76c6PdW01ru33Nu4uvoHKrGeGW-lab4SxBRIqaka6qyvrojRZxv85WJmgjY&usqp=CAU",
          time: "1j",
        },
        {
          name: "Julie Matt",
          content: t("to-start-a-live"),
          avatar:
            "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRZGrcVsaDt1KYSqHh6AcIS1cNreZvf6TCGWgzVdfGvRTu9AXBRcy0-oRoVJgXBKAdL8qM&usqp=CAU",
          time: `1${t("d")}`,
        },
        {
          name: "Julie Matt",
          content: t("to-start-a-live"),
          avatar:
            "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQnPsHyxR_Y76c6PdW01ru33Nu4uvoHKrGeGW-lab4SxBRIqaka6qyvrojRZxv85WJmgjY&usqp=CAU",
          time: `1${t("d")}`,
        },
        {
          name: "Julie Matt",
          content: t("to-start-a-live"),
          avatar:
            "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQnPsHyxR_Y76c6PdW01ru33Nu4uvoHKrGeGW-lab4SxBRIqaka6qyvrojRZxv85WJmgjY&usqp=CAU",
          time: `1${t("d")}`,
        },
        {
          name: "Julie Matt",
          content: t("to-start-a-live"),
          avatar:
            "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQnPsHyxR_Y76c6PdW01ru33Nu4uvoHKrGeGW-lab4SxBRIqaka6qyvrojRZxv85WJmgjY&usqp=CAU",
          time: `1${t("d")}`,
        },
        {
          name: "Julie Matt",
          content: t("to-start-a-live"),
          avatar:
            "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQnPsHyxR_Y76c6PdW01ru33Nu4uvoHKrGeGW-lab4SxBRIqaka6qyvrojRZxv85WJmgjY&usqp=CAU",
          time: `1${t("d")}`,
        },
        {
          name: "Julie Matt",
          content: t("to-start-a-live"),
          avatar:
            "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQnPsHyxR_Y76c6PdW01ru33Nu4uvoHKrGeGW-lab4SxBRIqaka6qyvrojRZxv85WJmgjY&usqp=CAU",
          time: `1${t("d")}`,
        },
        {
          name: "Julie Matt",
          content: t("to-start-a-live"),
          avatar:
            "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQnPsHyxR_Y76c6PdW01ru33Nu4uvoHKrGeGW-lab4SxBRIqaka6qyvrojRZxv85WJmgjY&usqp=CAU",
          time: `1${t("d")}`,
        },
      ],
    },
  ];
};

const FOOTER_IDS = {
  HOME: "home",
  SEARCH: "search",
  MESSAGING: "messaging",
  LIVE: "live",
  SETTINGS: "settings",
  PROFILE: "profile",
  REVENUES: "revenues",
};

const getFanFooters = (t: any) => {
  return [
    {
      id: FOOTER_IDS.HOME,
      name: t("home"),
      icon: FanFooterHomeIcon,
      activeIcon: FanFooterHomeActiveIcon,
      link: "/fan/home",
    },
    {
      id: FOOTER_IDS.SEARCH,
      name: t("search"),
      icon: FanFooterSearchIcon,
      activeIcon: FanFooterSearchActiveIcon,
      // link: "/common/category/search",
      link: "/common/discover",
    },
    {
      id: FOOTER_IDS.MESSAGING,
      name: t("messaging"),
      icon: FanFooterMessageIcon,
      activeIcon: FanFooterMessageActiveIcon,
      link: "/fan/message",
    },
    {
      id: FOOTER_IDS.LIVE,
      name: t("live"),
      icon: FanFooterLiveIcon,
      activeIcon: FanFooterLiveActiveIcon,
      link: "/p/fan/lives",
    },
    {
      id: FOOTER_IDS.SETTINGS,
      name: t("settings"),
      icon: FanFooterParametersIcon,
      activeIcon: FanFooterParametersActiveIcon,
      link: "/common/setting",
    },
  ];
};

const getCreatorFooters = (t: any) => {
  return [
    {
      id: FOOTER_IDS.SEARCH,
      name: t("search"),
      icon: FanFooterSearchIcon,
      activeIcon: FanFooterSearchActiveIcon,
      // link: "/common/category/search",
      link: "/common/discover",
    },
    {
      id: FOOTER_IDS.MESSAGING,
      name: t("messaging"),
      icon: FanFooterMessageIcon,
      activeIcon: FanFooterMessageActiveIcon,
      link: "/creator/message",
    },
    {
      id: FOOTER_IDS.HOME,
      name: "Home",
    },
    {
      id: FOOTER_IDS.REVENUES,
      name: t("revenues"),
      icon: CreatorFooterRevenueIcon,
      activeIcon: CreatorFooterRevenueActiveIcon,
      link: "/creator/revenue",
    },
    {
      id: FOOTER_IDS.PROFILE,
      name: t("profile"),
      icon: CreatorFooterProfileIcon,
      activeIcon: CreatorFooterProfileActiveIcon,
      link: "/creator/profile",
    },
  ];
};

const getCreatorHomeSubFooters = (t: any) => {
  return [
    {
      id: "Collection",
      name: t("collection"),
      description: t("collection-description"),
      icon: CreatorFooterCollectionIcon,
      link: "/creator/create/collection",
    },
    {
      id: "Push",
      name: t("media-push"),
      description: t("push-description"),
      icon: CreatorFooterPushIcon,
      link: "/creator/mediaPush",
    },
    {
      id: "Unlock",
      name: t("unlock-menu"),
      description: t("decrypt-description"),
      icon: CreatorFooterDecryptIcon,
      link: "/creator/createDecrypt",
    },
    {
      id: "Live",
      name: t("live"),
      description: t("live-description"),
      icon: CreatorFooterLiveIcon,
      link: "/creator/live",
    },
    {
      id: "Post",
      name: t("post"),
      description: t("post-description"),
      icon: CreatorFooterPostIcon,
      link: "/creator/publication",
    },
    // {
    //   id: "Story",
    //   name: t("story"),
    //   icon: CreatorFooterStoryIcon,
    // },
  ];
};

const TEXT = "TEXT";
const FILE = "FILE";

const CREATOR = "creator";
const FAN = "fan";

const USER_TYPES = {
  CREATOR,
  FAN,
};

const HELLO_MESSAGE = "hello-message";

/* const PENDING = "En Attente";
const ACCEPTED = "Accepter";
const REJECTED = "Refusé";
const DELIVERED = "Livré"; */
const PENDING = "pending";
const ACCEPTED = "accepted";
const REJECTED = "refused";
const DELIVERED = "delivered";

const CONVERSATION_DATE_FORMAT = "DD MMMM [à] HH:mm";
const MESSAGE_TIME_FORMAT = "HH:mm";

const FALLBACK_IMAGE =
  "data:image/png;base64,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";

const COUNTRY_LIST = [
  "Afghanistan",
  "Albania",
  "Algeria",
  "American Samoa",
  "Andorra",
  "Angola",
  "Anguilla",
  "Antarctica",
  "Antigua and Barbuda",
  "Argentina",
  "Armenia",
  "Aruba",
  "Australia",
  "Austria",
  "Azerbaijan",
  "Bahamas (the)",
  "Bahrain",
  "Bangladesh",
  "Barbados",
  "Belarus",
  "Belgium",
  "Belize",
  "Benin",
  "Bermuda",
  "Bhutan",
  "Bolivia (Plurinational State of)",
  "Bonaire, Sint Eustatius and Saba",
  "Bosnia and Herzegovina",
  "Botswana",
  "Bouvet Island",
  "Brazil",
  "British Indian Ocean Territory (the)",
  "Brunei Darussalam",
  "Bulgaria",
  "Burkina Faso",
  "Burundi",
  "Cabo Verde",
  "Cambodia",
  "Cameroon",
  "Canada",
  "Cayman Islands (the)",
  "Central African Republic (the)",
  "Chad",
  "Chile",
  "China",
  "Christmas Island",
  "Cocos (Keeling) Islands (the)",
  "Colombia",
  "Comoros (the)",
  "Congo (the Democratic Republic of the)",
  "Congo (the)",
  "Cook Islands (the)",
  "Costa Rica",
  "Croatia",
  "Cuba",
  "Curaçao",
  "Cyprus",
  "Czechia",
  "Côte d'Ivoire",
  "Denmark",
  "Djibouti",
  "Dominica",
  "Dominican Republic (the)",
  "Ecuador",
  "Egypt",
  "El Salvador",
  "Equatorial Guinea",
  "Eritrea",
  "Estonia",
  "Eswatini",
  "Ethiopia",
  "Falkland Islands (the) [Malvinas]",
  "Faroe Islands (the)",
  "Fiji",
  "Finland",
  "France",
  "French Guiana",
  "French Polynesia",
  "French Southern Territories (the)",
  "Gabon",
  "Gambia (the)",
  "Georgia",
  "Germany",
  "Ghana",
  "Gibraltar",
  "Greece",
  "Greenland",
  "Grenada",
  "Guadeloupe",
  "Guam",
  "Guatemala",
  "Guernsey",
  "Guinea",
  "Guinea-Bissau",
  "Guyana",
  "Haiti",
  "Heard Island and McDonald Islands",
  "Holy See (the)",
  "Honduras",
  "Hong Kong",
  "Hungary",
  "Iceland",
  "India",
  "Indonesia",
  "Iran (Islamic Republic of)",
  "Iraq",
  "Ireland",
  "Isle of Man",
  "Israel",
  "Italy",
  "Jamaica",
  "Japan",
  "Jersey",
  "Jordan",
  "Kazakhstan",
  "Kenya",
  "Kiribati",
  "Korea (the Democratic People's Republic of)",
  "Korea (the Republic of)",
  "Kuwait",
  "Kyrgyzstan",
  "Lao People's Democratic Republic (the)",
  "Latvia",
  "Lebanon",
  "Lesotho",
  "Liberia",
  "Libya",
  "Liechtenstein",
  "Lithuania",
  "Luxembourg",
  "Macao",
  "Madagascar",
  "Malawi",
  "Malaysia",
  "Maldives",
  "Mali",
  "Malta",
  "Marshall Islands (the)",
  "Martinique",
  "Mauritania",
  "Mauritius",
  "Mayotte",
  "Mexico",
  "Micronesia (Federated States of)",
  "Moldova (the Republic of)",
  "Monaco",
  "Mongolia",
  "Montenegro",
  "Montserrat",
  "Morocco",
  "Mozambique",
  "Myanmar",
  "Namibia",
  "Nauru",
  "Nepal",
  "Netherlands (the)",
  "New Caledonia",
  "New Zealand",
  "Nicaragua",
  "Niger (the)",
  "Nigeria",
  "Niue",
  "Norfolk Island",
  "Northern Mariana Islands (the)",
  "Norway",
  "Oman",
  "Pakistan",
  "Palau",
  "Palestine, State of",
  "Panama",
  "Papua New Guinea",
  "Paraguay",
  "Peru",
  "Philippines (the)",
  "Pitcairn",
  "Poland",
  "Portugal",
  "Puerto Rico",
  "Qatar",
  "Republic of North Macedonia",
  "Romania",
  "Russian Federation (the)",
  "Rwanda",
  "Réunion",
  "Saint Barthélemy",
  "Saint Helena, Ascension and Tristan da Cunha",
  "Saint Kitts and Nevis",
  "Saint Lucia",
  "Saint Martin (French part)",
  "Saint Pierre and Miquelon",
  "Saint Vincent and the Grenadines",
  "Samoa",
  "San Marino",
  "Sao Tome and Principe",
  "Saudi Arabia",
  "Senegal",
  "Serbia",
  "Seychelles",
  "Sierra Leone",
  "Singapore",
  "Sint Maarten (Dutch part)",
  "Slovakia",
  "Slovenia",
  "Solomon Islands",
  "Somalia",
  "South Africa",
  "South Georgia and the South Sandwich Islands",
  "South Sudan",
  "Spain",
  "Sri Lanka",
  "Sudan (the)",
  "Suriname",
  "Svalbard and Jan Mayen",
  "Sweden",
  "Switzerland",
  "Syrian Arab Republic",
  "Taiwan",
  "Tajikistan",
  "Tanzania, United Republic of",
  "Thailand",
  "Timor-Leste",
  "Togo",
  "Tokelau",
  "Tonga",
  "Trinidad and Tobago",
  "Tunisia",
  "Turkey",
  "Turkmenistan",
  "Turks and Caicos Islands (the)",
  "Tuvalu",
  "Uganda",
  "Ukraine",
  "United Arab Emirates (the)",
  "United Kingdom of Great Britain and Northern Ireland (the)",
  "United States Minor Outlying Islands (the)",
  "United States of America (the)",
  "Uruguay",
  "Uzbekistan",
  "Vanuatu",
  "Venezuela (Bolivarian Republic of)",
  "Viet Nam",
  "Virgin Islands (British)",
  "Virgin Islands (U.S.)",
  "Wallis and Futuna",
  "Western Sahara",
  "Yemen",
  "Zambia",
  "Zimbabwe",
  "Åland Islands",
];

const GENERAL = "GENERAL";
const SUBSCRIPTION = "SUBSCRIPTION";
const TO_DELIVER = "TO_DELIVER";
const SEARCH = "SEARCH";

const CONVERSATION_TYPES = {
  GENERAL,
  SUBSCRIPTION,
  TO_DELIVER,
  SEARCH,
};

const C_CURRENT_TAB = "c_currentTab";
const F_CURRENT_TAB = "f_currentTab";

const MAX_MEDIAS_TO_SEND = 10;
const MESSAGES_PER_PAGE = 15;

const HOURS_TO_EXPIRE = 72;

export const EURO_SYMBOLE = "€";

const CLEAR_MEDIUM = "CLEAR_MEDIUM";
const CLEAR = "CLEAR";
const BLURRED = "BLURRED";

const THUMBNAIL_TYPES = {
  CLEAR,
  CLEAR_MEDIUM,
  BLURRED,
};

const FILE_STATUS = {
  PROCESSED: "processed",
  UPLOADING: "uploading",
};

const MIN_STREAMING_SCHEDULED_LIVE_TIME_BEFORE_ENDING = 300;
const MIN_STREAMING_TIME_BEFORE_UPDATE = 20;
const UPDATE_STREAMING_TIME_EVERY_20_SECONDS = 20000;

const MAX_DESCRIPTION_LENGTH = 190;

const TARGET_PAGE = {
  creatorHelpPage: "creator/help",
  fanHelpPage: "fan/help",
  bugPage: "bug",
};

export enum REQUEST_LOADING_STATES {
  IDLE = "idle",
  PENDING = "pending",
  SUCCEEDED = "succeeded",
  FAILED = "failed",
}

export enum CONVERSATIONS_TYPES {
  GLOBAL = "GLOBAL",
  SEARCH = "SEARCH",
}

export enum CONVERSATIONS_FILTER_TYPES {
  UNREAD = "UNREAD",
  UNANSWERED = "UNANSWERED",
  ALL = "ALL",
}

const MAX_PRICE = Number(process.env.REACT_APP_MAX_PRICE) || 500;
const MIN_PRICE = 3;
const DEFAULT_HOME_PAGE_FEEDS = 15;
const DEFAULT_COLLECTION_PAGE_REPORT = 10;

const CHUNK_SIZE = 5 * 1024 * 1024; // 5MB chunks
const BATCH_SIZE = 6;

export const MAX_NAME_LENGTH = 16;
export const LIMIT_PER_PAGE = 15;

const QUICK_FILES_ALBUM_MAX_SIZE = 214748364800;

export const DISCOVER_APPROVED = "APPROVED";
export const DISCOVER_REJECTED = "REJECTED";
export const DISCOVER_PENDING = "PENDING";
export const DISCOVER_DELETED = "DELETED";
export const DISCOVER_EXPIRED = "EXPIRED";
export const DISCOVER_UPLOADING = "UPLOADING";
export const DISCOVER_TO_UPLOAD = "TO_UPLOAD";

export enum DISCOVER_TYPES {
  DISCOVER_APPROVED,
  DISCOVER_REJECTED,
  DISCOVER_PENDING,
  DISCOVER_DELETED,
  DISCOVER_EXPIRED,
  DISCOVER_UPLOADING,
  DISCOVER_TO_UPLOAD,
}

export {
  ACCEPTED,
  BATCH_SIZE,
  C_CURRENT_TAB,
  categories,
  CHUNK_SIZE,
  comments,
  CONVERSATION_DATE_FORMAT,
  CONVERSATION_TYPES,
  COUNTRY_LIST,
  CREATOR,
  DEFAULT_COLLECTION_PAGE_REPORT,
  DEFAULT_HOME_PAGE_FEEDS,
  DELIVERED,
  F_CURRENT_TAB,
  FALLBACK_IMAGE,
  FAN,
  FILE,
  FILE_STATUS,
  FOOTER_IDS,
  getCollectionAmounts,
  getCreatorFooters,
  getCreatorHomeSubFooters,
  getCreatorSettings,
  getDiscountExpirePeriods,
  getDiscountTypes,
  getEmailNotifications,
  getFanFooters,
  getFanSettings,
  getGenders,
  getLiveAccesses,
  getLiveAmounts,
  getMediaAmounts,
  getMonetizationsInformations,
  getNotifications,
  HELLO_MESSAGE,
  HOURS_TO_EXPIRE,
  LIVE_TYPES,
  lives,
  MAX_DESCRIPTION_LENGTH,
  MAX_MEDIAS_TO_SEND,
  MAX_PRICE,
  MESSAGE_TIME_FORMAT,
  messages,
  MESSAGES_PER_PAGE,
  MIN_PRICE,
  MIN_STREAMING_SCHEDULED_LIVE_TIME_BEFORE_ENDING,
  MIN_STREAMING_TIME_BEFORE_UPDATE,
  PAYMENT_TYPES,
  PENDING,
  posts,
  privateGalleries,
  privateMedias,
  PRMOTION_EXPIRATION_TIME_TYPE,
  profile,
  profiles,
  PROMOTION_DISCOUNT_TYPE,
  PROMOTION_PROMO_ON,
  QUICK_FILES_ALBUM_MAX_SIZE,
  REJECTED,
  revenues,
  TARGET_PAGE,
  TEXT,
  THUMBNAIL_TYPES,
  UPDATE_STREAMING_TIME_EVERY_20_SECONDS,
  USER_TYPES,
};

// EXPIRES IN FRONTEND TEMPORARY IN 7D UNTIL FIND A BETTER SOLUTION
export const REFRESH_TOKEN_EXPIRE_AT = 7 * 24 * 60 * 60 * 1000; // 7 days
export const REFRESH_TOKEN_EXPIRE_DAYS = "7d";

export const ACCESS_TOKEN_EXPIRE_AT = 7 * 24 * 60 * 60 * 1000; // 7 days
export const ACCESS_TOKEN_EXPIRE_DAYS = "7d";
